import { defineMessages } from 'react-intl';

type MessageKeys = 'splitLayoutExpandButtonLabel' | 'splitLayoutCollapseButtonLabel';

const messages: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		splitLayoutExpandButtonLabel: {
			id: 'conversation-assistant.split-layout.split-layout-toggle.splitLayoutExpandButtonLabel.non-final',
			defaultMessage: 'View context',
			description:
				'Tooltip lanel for the header button that expands the chat panel to reveal a right-side panel that displays session context.',
		},
		splitLayoutCollapseButtonLabel: {
			id: 'conversation-assistant.split-layout.split-layout-toggle.splitLayoutCollapseButtonLabel.non-final',
			defaultMessage: 'Hide context',
			description:
				'Tooltip lanel for the header button that collapses the chat panel to hide the right-side panel that displays session context.',
		},
	});

export default messages;
